import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
    state: {
        currentUser: null,
        currentType: '内部类型',
        smartType: '',
        orgType: null,
        deleteSuccsee: true,
        currentDeploy: '菜单配置',
        currentIdx: null,
        parttimerRowData: [],
        adminRowData: [],
        groupMemberRowData: [],
        jobMemberRowData: [],
        jobDynamicMemberRowData: [],
        currentRole: '',
        currentRoleDecsription: '',
        currentChecked: [],
        configureInit: true,
        configureSubMap: true,
        parentDic: true,
        subDic: true,
        menuType: true,
        menu: true,
        jobType: true,
        job: true,
        loading: false,
        dataUpdate: true,
        depPositionUpdate: true,
        treeStatus: true,
        parentId: null,
        newParentId: null,
        appendData: null,
        jobType: null,
        showBulkImport: false,
        showButton: false,
        departmentBtn: false,
        userBtn: false,
        jobAddBtn: false,
        deptJobAdminBtn: false,
        changeStatus: true,
        dnStatus: '',
        refresh: true,
        groupInit: true,
        cn: '',
        emptySearch: false,
        resultEmpty: false,
        searchResult: true,
        oDefault: '',
        jobRefresh: true, //刷新岗位主数据
        memberRefresh: true, //静态
        jobDynamicMember: true, //动态
        jobsSelectValue: '',
        jobsSelectId: '',
        showDeptJobMember: false,
        deptJobAdminRowData: [],
        deptShowMore: false,
        userShowMore: false,
        groupShowMore: false,
        jobShowMore: false,
        userSearchRefresh: false,
        searchKeyword: null,
        jobSearchRefresh: false,
        searchJobKeyword: null,
        groupSearchRefresh: false,
        searchGroupKeyword: null,
        configureSearchKeyword: null,
        parentMapSearchRefresh: false,
        subMapSearchRefresh: false,
        parentDicSearchRefresh: false,
        subDicSearchRefresh: false,
        menuTypeSearchRefresh: false,
        menuSearchRefresh: false,
        jobTypeSearchRefresh: false,
        jobSearchRefresh: false,
        increment: false,
        authorizesUser: null,
        // unfold: false,
        flag1: false,
        flag2: false,
        jobSelecto: null,
        bsType: null,
        jobBorgAdd: false,
        jobBorgView: false,
        jobBorgButton: false,
        createType: '',
        isokData: true,
        appendData: {},
        isEditok: false,
        count: false,
        showOrgDept: [], // 新版岗位是否显示业务组织按钮
        startLoading: false,
        deleteJobMembers: false,
        // moveDeptData: false,
        // moveDeptOk: false,
        jobsSearchRefreshStatus: true,
        scrollTimeOut: true,
        // ----------
        jobList: [],
        jobKey: [],
        middleCheckedData: [],
        deptEditOk: false,
        pass: false, // 稽查维度 点搜索按钮是否通过
        rStatusChange: false,
        bodyStatus: null, // 稽查维度 静、动态成员删除或新增完成后更新左侧部门状态
        clearList: false, // 稽查维度 点击搜索时清空右侧表格数据,
        saveGroupOperates: [],
        groupTableOperates: [],
        saveCurrentCreateType: null, // 保存当前的创建类型
        jobDataInit: [], // 稽查维度 点击流程二级的id
        maskLoadingFirst: false,
        deptAddSub: null, // 用户模块，创建部门成功后存的新部门数据
        deptEdit: null, // 用户模块，创建部门成功后存的新部门数据
        deptDelete: null, // 用户模块，删除的部门信息
        deptDeleteOk: false, // 用户模块，删除部门成功后存的新部门数据
        userModuleBtnGroup: false
    },
    actions: {
        deleteStatus(ctx, status) {
            ctx.commit('deleteStatus', status);
        },
        maskLoadingFirst(ctx, status) {
            ctx.commit('maskLoadingFirst', status);
        },
        scrollTimeOut(ctx, status) {
            ctx.commit('scrollTimeOut', status);
        },
        isEditok(ctx, status) {
            ctx.commit('isEditok', status);
        },
        appendData(ctx, status) {
            ctx.commit('appendData', status);
        },
        isokData(ctx, status) {
            ctx.commit('isokData', status);
        },
        createType(ctx, status) {
            ctx.commit('createType', status);
        },
        jobBorgButton(ctx, status) {
            ctx.commit('jobBorgButton', status);
        },
        jobBorgView(ctx, status) {
            ctx.commit('jobBorgView', status);
        },
        jobBorgAdd(ctx, status) {
            ctx.commit('jobBorgAdd', status);
        },
        jobSelecto(ctx, status) {
            ctx.commit('jobSelecto', status);
        },
        changeBsType(ctx, status) {
            ctx.commit('changeBsType', status);
        },
        searchResult(ctx, status) {
            ctx.commit('searchResult', status);
        },
        changeConfigureInit(ctx, status) {
            ctx.commit('changeConfigureInit', status);
        },
        changeConfigureSubMap(ctx, status) {
            ctx.commit('changeConfigureSubMap', status);
        },
        changeParentDic(ctx, status) {
            ctx.commit('changeParentDic', status);
        },
        changeSubDic(ctx, status) {
            ctx.commit('changeSubDic', status);
        },
        changeMenuType(ctx, status) {
            ctx.commit('changeMenuType', status);
        },
        changeMenu(ctx, status) {
            ctx.commit('changeMenu', status);
        },
        changeJobType(ctx, status) {
            ctx.commit('changeJobType', status);
        },
        changeJob(ctx, status) {
            ctx.commit('changeJob', status);
        },
        changeDataUpdate(ctx, status) {
            ctx.commit('changeDataUpdate', status);
        },
        changeDepPositionUpdate(ctx, status) {
            ctx.depPositionUpdate('changeDepPositionUpdate', status);
        },
        changeTreeStatus(ctx, status) {
            ctx.commit('changeTreeStatus', status);
        },
        changeAppendData(ctx, status) {
            ctx.commit('changeAppendData', status);
        },
        changeInit(ctx, status) {
            ctx.commit('changeInit', status)
        },
        changeStatus(ctx, status) {
            ctx.commit('changeStatus', status)
        },
        refresh(ctx, status) {
            ctx.commit('refresh', status)
        },
        groupInit(ctx, status) {
            ctx.commit('groupInit', status)
        },
        cnChange(ctx, status) {
            ctx.commit('cnChange', status)
        },
        emptySearch(ctx, status) {
            ctx.commit('emptySearch', status)
        },
        resultEmpty(ctx, status) {
            ctx.commit('resultEmpty', status)
        },
        oDefault(ctx, status) {
            ctx.commit('oDefault', status)
        },
        jobRefresh(ctx, status) {
            ctx.commit('jobRefresh', status)
        },
        memberRefresh(ctx, status) {
            ctx.commit('memberRefresh', status)
        },
        changeJobDynamicMember(ctx, status) {
            ctx.commit('changeJobDynamicMember', status);
        },
        jobsSelectValue(ctx, status) {
            ctx.commit('jobsSelectValue', status)
        },
        jobsSelectId(ctx, status) {
            ctx.commit('jobsSelectId', status)
        },
        changeShowDeptJobMember(ctx, status) {
            ctx.commit('changeShowDeptJobMember', status)
        },
        changeDeptJobAdminRowData(ctx, status) {
            ctx.commit('changeDeptJobAdminRowData', status)
        },
        changeUserSearchRefresh(ctx, status) {
            ctx.commit('changeUserSearchRefresh', status)
        },
        changeSearchKeyword(ctx, status) {
            ctx.commit('changeSearchKeyword', status)
        },
        changeJobSearchRefresh(ctx, status) {
            ctx.commit('changeJobSearchRefresh', status)
        },
        changeSearchJobKeyword(ctx, status) {
            ctx.commit('changeSearchJobKeyword', status)
        },
        changeGroupSearchRefresh(ctx, status) {
            ctx.commit('changeGroupSearchRefresh', status)
        },
        changeSearchGroupKeyword(ctx, status) {
            ctx.commit('changeSearchGroupKeyword', status)
        },
        changeConfigureSearchKeyword(ctx, status) {
            ctx.commit('changeConfigureSearchKeyword', status)
        },
        changeParentMapSearchRefresh(ctx, status) {
            ctx.commit('changeParentMapSearchRefresh', status)
        },
        changeSubMapSearchRefresh(ctx, status) {
            ctx.commit('changeSubMapSearchRefresh', status)
        },
        changeParentDicSearchRefresh(ctx, status) {
            ctx.commit('changeParentDicSearchRefresh', status)
        },
        changeSubDicSearchRefresh(ctx, status) {
            ctx.commit('changeSubDicSearchRefresh', status)
        },
        changeMenuTypeSearchRefresh(ctx, status) {
            ctx.commit('changeMenuTypeSearchRefresh', status)
        },
        changeMenuSearchRefresh(ctx, status) {
            ctx.commit('changeMenuSearchRefresh', status)
        },
        changeJobTypeSearchRefresh(ctx, status) {
            ctx.commit('changeJobTypeSearchRefresh', status)
        },
        changeJobSearchRefresh(ctx, status) {
            ctx.commit('changeJobTypeSearchRefresh', status)
        },
        changeCount(ctx, status) {
            ctx.commit('changeCount', status)
        },
        isShowOrgDept(ctx, status) { // 新版岗位是否显示业务组织按钮
            ctx.commit('isShowOrgDept', status)
        },
        changeStartLoading(ctx, status) { // 改变用户莫模块搜索loading状态
            ctx.commit('changeStartLoading', status)
        },
        deleteJobMembersFun(ctx, status) { // 删除通用岗位成员状态监听
            ctx.commit('deleteJobMembersFun', status);
        },
        // moveDeptData (ctx, status) { // 保存移动的那个部门信息
        //     ctx.commit('moveDeptData', status);
        // },
        // moveDeptOk (ctx, status) { // 部门移动状态
        //     ctx.commit('moveDeptOk', status);
        // },
        changeJobsSearchRefreshStatus(ctx, status) {
            ctx.commit('changeJobsSearchRefreshStatus', status);
        },
        deptEditOk(ctx, status) {
            ctx.commit('deptEditOk', status);
        },
        changeDeptAddSub(ctx, status) {
            ctx.commit('changeDeptAddSub', status);
        },
        changeDeptEdit(ctx, status) {
            ctx.commit('changeDeptEdit', status);
        },
        changeDeptDelete(ctx, status) {
            ctx.commit('changeDeptDelete', status);
        },
        deptDeleteOk(ctx, status) {
            ctx.commit('deptDeleteOk', status);
        },
    },
    mutations: {
        maskLoadingFirst(state, val) {
            state.maskLoadingFirst = val;
        },
        saveCurrentUser(state, val) {
            state.currentUser = val;
        },
        changeCurrentType(state, val) {
            state.currentType = val;
        },
        changeSmartType(state, val) {
            state.smartType = val;
        },
        isEditok(state, val) {
            state.isEditok = val;
        },
        appendData(state, val) {
            state.appendData = val;
        },
        isokData(state, val) {
            state.isokData = val;
        },
        createType(state, val) {
            state.createType = val;
        },
        jobBorgView(state, val) {
            state.jobBorgView = val;
        },
        jobBorgButton(state, val) {
            state.jobBorgButton = val;
        },
        jobBorgAdd(state, val) {
            state.jobBorgAdd = val;
        },
        jobSelecto(state, val) {
            state.jobSelecto = val;
        },
        changeBsType(state, val) {
            state.bsType = val;
        },
        deleteStatus(state, status) {
            state.deleteSuccsee = status;
        },
        changeCurrentDeploy(state, val) {
            state.currentDeploy = val;
        },
        changeCurrentIdx(state, val) {
            state.currentIdx = val;
        },
        changeParttimerRowData(state, val) {
            state.parttimerRowData = val;
        },
        changeAdminRowData(state, val) {
            state.adminRowData = val;
        },
        changeGroupMemberRowData(state, val) {
            state.groupMemberRowData = val;
        },
        changeJobMemberRowData(state, val) {
            state.jobMemberRowData = val;
        },
        changeJobDynamicMemberRowData(state, val) {
            state.jobDynamicMemberRowData = val;
        },
        changeCurrentRole(state, val) {
            state.currentRole = val;
        },
        changeCurrentRoleDecsription(state, val) {
            state.currentRoleDecsription = val;
        },
        changeCurrentChecked(state, val) {
            state.currentChecked = val;
        },
        changeConfigureInit(state, val) {
            state.configureInit = val;
        },
        changeConfigureSubMap(state, val) {
            state.configureSubMap = val;
        },
        changeParentDic(state, val) {
            state.parentDic = val;
        },
        changeSubDic(state, val) {
            state.subDic = val;
        },
        changeMenuType(state, val) {
            state.menuType = val;
        },
        changeMenu(state, val) {
            state.menu = val;
        },
        changeJobType(state, val) {
            state.jobType = val;
        },
        changeJob(state, val) {
            state.job = val;
        },
        changeLoading(state, val) {
            state.loading = val;
        },
        changeDataUpdate(state, val) {
            state.dataUpdate = val;
        },
        changeDepPositionUpdate() {
            state.depPositionUpdate = val;
        },
        changeOrgType(state, val) {
            state.orgType = val;
        },
        changeTreeStatus(state, val) {
            state.treeStatus = val;
        },
        changeParentId(state, status) {
            state.parentId = status;
        },
        changeNewParentId(state, val) {
            state.newParentId = val;
        },
        changeAppendData(state, val) {
            state.appendData = val;
        },
        changeJobType(state, val) {
            state.jobType = val;
        },
        changeShowBulkImport(state, val) {
            state.showBulkImport = val;
        },
        changeShowButton(state, val) {
            state.showButton = val;
        },
        changeDepartmentBtn(state, val) {
            state.departmentBtn = val;
        },
        changeUserBtn(state, val) {
            state.userBtn = val;
        },
        changeJobAddBtn(state, val) {
            state.jobAddBtn = val;
        },
        changeDeptJobAdminBtn(state, val) {
            state.deptJobAdminBtn = val;
        },
        changeInit(state, status) {
            state.changeStatus = status;
        },
        changeStatus(state, status) {
            state.dnStatus = status;
        },
        refresh(state, status) {
            state.refresh = status;
        },
        groupInit(state, status) {
            state.groupInit = status;
        },
        cnChange(state, status) {
            state.cn = status;
        },
        emptySearch(state, status) {
            state.emptySearch = status;
        },
        resultEmpty(state, status) {
            state.resultEmpty = status;
        },
        searchResult(state, status) {
            state.searchResult = status;
        },
        oDefault(state, status) {
            state.oDefault = status;
        },
        jobRefresh(state, status) {
            state.jobRefresh = status;
        },
        memberRefresh(state, status) {
            state.memberRefresh = status;
        },
        changeJobDynamicMember(state, status) {
            state.jobDynamicMember = status;
        },
        jobsSelectValue(state, status) {
            state.jobsSelectValue = status;
        },
        jobsSelectId(state, status) {
            state.jobsSelectId = status;
        },
        changeShowDeptJobMember(state, status) {
            state.showDeptJobMember = status;
        },
        changeDeptJobAdminRowData(state, status) {
            state.deptJobAdminRowData = status;
        },
        changeDeptShowMore(state, status) {
            state.deptShowMore = status;
        },
        changeUserShowMore(state, status) {
            state.userShowMore = status;
        },
        changeGroupShowMore(state, status) {
            state.groupShowMore = status;
        },
        changeJobShowMore(state, status) {
            state.jobShowMore = status;
        },
        changeUserSearchRefresh(state, status) {
            state.userSearchRefresh = status;
        },
        changeSearchKeyword(state, status) {
            state.searchKeyword = status;
        },
        changeJobSearchRefresh(state, status) {
            state.jobSearchRefresh = status;
        },
        changeSearchJobKeyword(state, status) {
            state.searchJobKeyword = status;
        },
        changeGroupSearchRefresh(state, status) {
            state.groupSearchRefresh = status;
        },
        changeSearchGroupKeyword(state, status) {
            state.searchGroupKeyword = status;
        },
        changeConfigureSearchKeyword(state, status) {
            state.configureSearchKeyword = status;
        },
        changeParentMapSearchRefresh(state, status) {
            state.parentMapSearchRefresh = status;
        },
        changeSubMapSearchRefresh(state, status) {
            state.subMapSearchRefresh = status;
        },
        changeParentDicSearchRefresh(state, status) {
            state.parentDicSearchRefresh = status;
        },
        changeSubDicSearchRefresh(state, status) {
            state.subDicSearchRefresh = status;
        },
        changeMenuTypeSearchRefresh(state, status) {
            state.menuTypeSearchRefresh = status;
        },
        changeMenuSearchRefresh(state, status) {
            state.menuSearchRefresh = status;
        },
        changeJobTypeSearchRefresh(state, status) {
            state.jobTypeSearchRefresh = status;
        },
        changeJobSearchRefresh(state, status) {
            state.jobSearchRefresh = status;
        },
        increment(state, val) {
            state.increment = val;
        },
        saveAuthorizesUser(state, val) {
            state.authorizesUser = val;
        },
        // changeUnfold(state, val) {
        //     state.unfold = val;
        // },
        saveFlag1(state, val) {
            state.flag1 = val;
        },
        saveFlag2(state, val) {
            state.flag2 = val;
        },
        changeCount(state, val) {
            state.count = val;
        },
        isShowOrgDept(state, val) { // 新版岗位是否显示业务组织按钮
            state.showOrgDept = val;
        },
        changeStartLoading(state, val) { // 改变用户模块搜索loading状态
            state.startLoading = val;
        },
        deleteJobMembersFun(state, val) { // 删除岗位成员状态监听
            state.deleteJobMembers = val;
        },
        // moveDeptData (state, val) { // 保存移动的那个部门信息
        //     state.moveDeptData = val;
        // },
        // moveDeptOk (state, val) { // 部门移动状态
        //     state.moveDeptOk = val;
        // },
        changeJobsSearchRefreshStatus(state, val) {
            state.jobsSearchRefreshStatus = val;
        },
        scrollTimeOut(state, val) {
            state.scrollTimeOut = val;
        },
        saveJobList(state, val) {
            state.jobList = val;
        },
        saveJobKey(state, val) {
            state.jobKey = val;
        },
        saveMiddleCheckedData(state, val) {
            state.middleCheckedData = val;
        },
        deptEditOk(state, val) {
            state.deptEditOk = val;
        },
        pass(state, val) {
            state.pass = val;
        },
        rStatusChange(state, val) {
            state.rStatusChange = val;
        },
        bodyStatus(state, val) {
            state.bodyStatus = val;
        },
        clearList(state, val) {
            state.clearList = val;
        },
        saveGroupOperates(state, val) {
            state.saveGroupOperates = val;
        },
        groupTableOperates(state, val) {
            state.groupTableOperates = val;
        },
        saveCurrentCreateType(state, val) {
            state.saveCurrentCreateType = val;
        },
        saveJobDataInit(state, val) {
            state.jobDataInit = val;
        },
        changeDeptAddSub(state, val) {
            state.deptAddSub = val;
        },
        changeDeptEdit(state, val) {
            state.deptEdit = val;
        },
        changeDeptDelete(state, val) {
            state.deptDelete = val;
        },
        deptDeleteOk(state, val) {
            state.deptDeleteOk = val;
        },
        setUserModuleBtnGroup(state, val) {
            state.userModuleBtnGroup = val;
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js